/* tslint:disable */
/* eslint-disable */
export enum InventoryTransactionType {
  Inbound = 'inbound',
  Outbound = 'outbound'
}
